import React, { useEffect, useContext, useState } from 'react';
import { ButtonWrapper } from './elements';
import { ControlButton } from './ControlButton';
import { CarouselContext } from './CarouselContext';
export const Controls = () => {
  const {
    carouselContainer,
    elementWidth,
    isHovering,
    showControls
  } = useContext(CarouselContext);
  const [leftButtonDisabled, setLeftButtonDisabled] = useState(false);
  const [rightButtonDisabled, setRightButtonDisabled] = useState(false);
  const getVisibility = disabled => {
    if (disabled) {
      if (showControls === 'always') return 'disabled';
      if (showControls === 'onHover') return 'hidden';
    }
    return 'visible';
  };
  useEffect(() => {
    const carousel = carouselContainer.current;
    let itemWidth;
    if (elementWidth === '100%') itemWidth = carousel.clientWidth;else itemWidth = parseFloat(elementWidth) * 16;
    const listener = () => {
      setLeftButtonDisabled(carousel.scrollLeft < itemWidth);
      const canScroll = carousel.scrollWidth > carousel.clientWidth;
      setRightButtonDisabled(!canScroll || carousel.clientWidth + carousel.scrollLeft > carousel.scrollWidth - itemWidth / 2);
    };
    listener();
    carousel.addEventListener('scroll', listener);
    return () => {
      carousel.removeEventListener('scroll', listener);
    };
  }, [elementWidth, carouselContainer.current]);
  return /*#__PURE__*/React.createElement(ButtonWrapper, {
    $isRelative: showControls === 'onHover'
  }, /*#__PURE__*/React.createElement(ControlButton, {
    visibility: getVisibility(leftButtonDisabled),
    $isVisible: showControls === 'always' || isHovering,
    direction: "left"
  }), /*#__PURE__*/React.createElement(ControlButton, {
    visibility: getVisibility(rightButtonDisabled),
    $isVisible: showControls === 'always' || isHovering,
    direction: "right"
  }));
};